import React from "react";
import { BsEyeFill } from "react-icons/bs";
import { Link } from "react-router-dom";

import { AiFillAudio } from "react-icons/ai";
import { FaChalkboardTeacher } from "react-icons/fa";
import CardSchedule from "../Reuse/CardSchedule";

function StarShowcase() {
  const link = "/superstar-admin/schedule/single";

  return (
    <>
      <div className="row">
        <div className="col-md-3 mb-3">
          <div className="card bg-black border-warning">
            <div className="pt-3 d-flex justify-content-center align-items-center text-warning">
              <AiFillAudio size={50} />
            </div>

            <div className="pt-2 d-flex justify-content-center align-items-center text-light">
              <h5>Marketplace</h5>
            </div>

            <Link
              to={{ pathname: link, state: { title: "Marketplace" } }}
              className="Link w-100"
            >
              <button className="btn card-schedule-btn text-light fw-bold mt-2 w-100">
                <BsEyeFill />
              </button>
            </Link>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-black border-warning">
            <div className="pt-3 d-flex justify-content-center align-items-center text-warning">
              <AiFillAudio size={50} />
            </div>

            <div className="pt-2 d-flex justify-content-center align-items-center text-light">
              <h5>Auction</h5>
            </div>

            <Link
              to={{ pathname: link, state: { title: "Auction" } }}
              className="Link w-100"
            >
              <button className="btn card-schedule-btn text-light fw-bold mt-2 w-100">
                <BsEyeFill />
              </button>
            </Link>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-black border-warning">
            <div className="pt-3 d-flex justify-content-center align-items-center text-warning">
              <AiFillAudio size={50} />
            </div>

            <div className="pt-2 d-flex justify-content-center align-items-center text-light">
              <h5>Souvenir</h5>
            </div>

            <Link
              to={{ pathname: link, state: { title: "Souvenir" } }}
              className="Link w-100"
            >
              <button className="btn card-schedule-btn text-light fw-bold mt-2 w-100">
                <BsEyeFill />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default StarShowcase;
